// Pure-logic error utilities extracted from api/index.js so they can be
// tested without pulling in platform-specific / ESM-only API dependencies.

// Return the value as-is if it is a string, otherwise JSON-stringify it.
const stringOrJson = val => (typeof val === 'string' ? val : JSON.stringify(val));

// Extract a human-readable error message from an axios-style error object.
function getErrorMessage(error) {
  if (error.response) {
    if (error.response.status === 404) return 'Server Error: 404';
    if (error.response.data) {
      const data = error.response.data;
      if (typeof data === 'string') return data;
      const msg = data.error || data.message || data.detail;
      if (msg) return stringOrJson(msg);
      return JSON.stringify(data);
    }
    return `Server Error: ${error.response.status}`;
  }
  if (error.request) {
    return 'No response from server';
  }
  return error.message;
}

export { stringOrJson, getErrorMessage };
